import React from "react";
import { Col, Container, Row } from "react-bootstrap";
// import editor from "../../Assets/Projects/codeEditor.png";
import eclipse from "../../Assets/Projects/eclipse.png";
// import emotion from "../../Assets/Projects/emotion.png";
import interview from "../../Assets/Projects/interview.png";
import taskManager from "../../Assets/Projects/taskManager.png";
import wms from "../../Assets/Projects/wms.png";
import Particle from "../Particle";
import ProjectCard from "./ProjectCards";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={eclipse}
              isBlog={false}
              title="Eclipse.Xdr"
              description="Cyber Defense Portal (CDP) is a security portal includes third-party vendors API’s which detect threat and vulnerability and raise ticket, perform automation actions in order to block and allow suspected IP and Domain. It also includes a dashboard which shows the threat and vulnerability details."
              demoLink="https://eclipse.cyberstash.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={wms}
              isBlog={false}
              title="WareHouse Management System"
              description="lead the backend development for a Warehouse Management System as part of the Code Olympics Program. The system, built using Spring Boot, served as a platform connecting owners and farmers. It enabled farmers to request storage space for their grains, which owners could then approve or reject. My role involved designing and implementing the backend architecture, including user authentication, request handling, and database management."
              ghLink="https://github.com/Navinjoshi1301/warehouse_management"
             
            />
          </Col>

          {/* <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Editor.io"
              description="which supports GFM, Custom Html tags with toolbar and instant preview.Both the editor supports auto save of work using Local Storage"
              ghLink="https://github.com/soumyajit4419/Editor.io"
              demoLink="https://editor.soumya-jit.tech/"
            />
          </Col> */}

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={taskManager}
              isBlog={false}
              title="Task Manager"
              description="Developed a task management app using JS, HTML, CSS, and Bootstrap. Enabled dynamic task creation, editing, and deletion for efficient organization. Implemented responsive design and data persistence for seamless user experience. Integrated drag-and-drop functionality for intuitive task prioritization. Enhanced productivity and usability through user-centric design principles."
              ghLink="https://github.com/soumyajit4419/Plant_AI"
              demoLink="https://plant49-ai.herokuapp.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={interview}
              isBlog={false}
              title="Student level Project"
              description="Developed a project using Java Swing, MySQL, and JDBC. The project allows users to manage student levels, such as 1a, 1b, 1c, with functionalities to update levels and delete students. In summary, it's a Java-based application for efficiently organizing and modifying student information and their corresponding academic levels."
              ghLink="https://github.com/soumyajit4419/AI_For_Social_Good"
              // demoLink="https://www.youtube.com/watch?v=dQw4w9WgXcQ&ab_channel=RickAstley" <--------Please include a demo link here
            />
          </Col>
{/* 
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Face Recognition and Emotion Detection"
              description=""
              // demoLink="https://blogs.soumya-jit.tech/"
            />
          </Col> */}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
